export const getTotalUnreadCount = (allChats, userId) => {
    if (!userId || !allChats?.length) return 0;

    return allChats.reduce(
        (total, chat) => total + (Number(chat[userId]) || 0),
        0
    );
};

export const formatUnreadCount = (count) => {
    if (!count || count <= 0) return null;
    return count > 99 ? '99+' : String(count);
};
